'use strict';

module Patersons {

    export interface ViewOrderRequestsScope extends ng.IScope {
        viewOrderRequestsForm: ng.IFormController;
        parentController: AbstractController;
        events: Patersons.ViewOrderRequestsViewCtrl;
        errorHandler: any;
        investorOrders: Array<OrderRequest>;
        isError: boolean;
        isSubmitted: boolean;
    }

    export class ViewOrderRequestsViewCtrl extends AbstractController {
        scope: Patersons.ViewOrderRequestsScope;
        portfolioService: Patersons.PortfolioService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'portfolioService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, portfolioService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.portfolioService = portfolioService;
            this.scope.parentController = this;
            this.scope.events = this;
            this.scope.isError = false;
            this.scope.isSubmitted = false;

            this.getOrderRequests();
        }

        order = function (predicate) {
            this.scope.reverse = (this.scope.predicate === predicate) ? !this.scope.reverse : false;
            this.scope.predicate = predicate;
        };
        cancelOrder = function (orderToCancel: OrderRequest) {
            this.createCancelOrder(orderToCancel);
        };
        getOrderRequests() {
            var promise: ng.IHttpPromise<any> = this.portfolioService.getOrderRequests();
            promise.then(
                (result) => {
                    this.scope.investorOrders = result.data.value;
                },
                (reason) => {
                    this.portfolioService.errorHandler = reason.data;
                }
            );
        }
        createCancelOrder(order: OrderRequest) {
            var cancelOrder : OrderRequest = new OrderRequest();
            cancelOrder.orderAction = "Cancel";
            cancelOrder.portfolioId = order.portfolioId;
            cancelOrder.price = order.price;
            cancelOrder.securityCode = order.securityCode;
            cancelOrder.volume = order.volume;
            cancelOrder.requestDateTime = new Date();
            cancelOrder.buyAtMarketRate = true;
            cancelOrder.orderNumber = order.id;

            var promise: ng.IHttpPromise<any> = this.portfolioService.createCancelOrder(cancelOrder);
            promise.then(
                (result) => {
                    this.scope.isSubmitted = result.status == 200;
                    this.scope.isError = false;
                    this.getOrderRequests();
                },
                (reason) => { // error handling
                    this.scope.isError = true;
                    this.scope.isSubmitted = false;
                }
            );
        }

    }
}
